import React, { Suspense } from 'react'

const OrderLimitPageBase = React.lazy(() => import('./OrderLimit'))

export const OrderLimitPage = () => (
  <Suspense fallback={null}>
    <OrderLimitPageBase />
  </Suspense>
)
